<mat-card class="tile__card" [class.tile__card--together]="isTogetherVariant" appearance="outlined" [routerLink]="link">
  @if (isTogetherVariant) {
    <div class="tile__together-image">
      <img src="assets/ts-mark.svg" alt="" class="tile__together-mark" />
    </div>
  } @else {
    <img mat-card-image src="{{imagePath}}" alt="">
  }
  <mat-card-content class="tile__container" [class.tile__container--together]="isTogetherVariant">
    <mat-card-subtitle class="tile__text-color" [class.tile__text-color--together]="isTogetherVariant">{{ title | translate }}</mat-card-subtitle>
    <mat-icon
      class="tile__icon"
      aria-hidden="false"
      role="img"
      [attr.aria-label]="ariaLabel"
      fontIcon="{{iconName}}"
    ></mat-icon>
  </mat-card-content>
</mat-card>
